<template>
  <div>
    <div class="recharge-view right_auth">
      <div class="theme">在线充值</div>
      <div class="info">
        <p class="account">
          充值账户：{{
            userInfo.userPhone || userInfo.userPetname || userInfo.userNumber
          }}
        </p>
        <p class="money">
          充值金额：<input
            type="number"
            v-model="money"
            @change="changeMoney"
          />
          <span>请输入您要充值的金额，比如500</span>
        </p>
      </div>
      <div class="way">
        <p class="name">请选择支付方式</p>
        <ul>
          <li @click="submitPay(payWayLs[1].id)">微信支付</li>
          <li @click="submitPay(payWayLs[0].id)">支付宝支付</li>
        </ul>
      </div>
      <div class="remind clearfix">
        <p class="name">温馨提示：</p>
        <ul>
          <li>
            1、充值成功后，余额可能存在延迟现象，
            一般1到5分钟内到账，如有问题，请咨询客服; <i></i>
          </li>
          <li>2、充值金额输入值必须是不小于1且不大于50000的正整数;</li>
          <li>
            3、您支付宝和微信进行充值，如果遇到任何支付问题可以查看在线客服帮助;
          </li>
          <li>4、充值完成后，您可以进入账户记录页面进行查看余额充值状态。</li>
          <li>5.充值金额不可退还。</li>
          <li>本方案解释权归深度配音所有。</li>
        </ul>
      </div>
    </div>
    <!-- 微信&&支付宝支付二维码弹出页 -->
    <sd-modal v-show="payStatus">
      <div
        class="pay_way"
        :class="{
          pay_wx: payChannel == payWayLs[1].id,
          pay_zfb: payChannel == payWayLs[0].id,
        }"
      >
        <div class="title">
          <i class="close" @click="cancelPay"></i>
          <p class="way" v-if="payChannel == payWayLs[1].id">微信支付</p>
          <p class="way" v-else>支付宝支付</p>
          <!-- <p class="num">订单编号：{{orderNums}}</p> -->
        </div>
        <div class="content" v-show="payStatus == 'waiting'">
          <div class="inner">
            <p class="money">
              付款金额：<span>￥{{ money }}</span>
            </p>
            <div class="erwm">
              <img style="height: 200px" :src="QRCode | preImgPath" alt="" />
              <p class="erwm_txt" v-if="payChannel == payWayLs[1].id">
                使用微信扫描二维码支付
              </p>
              <p class="erwm_txt" v-else>使用支付宝扫描二维码支付</p>
            </div>
            <p class="remind">
              付款成功请不要关闭此页面，付款后页面没有跳转，请根据您的情况联系客服
            </p>
            <div class="contact">
              支付遇到问题？ 请联系客服
              <div class="btn kf_btn">
                <div class="kf_list_wrap">
                  <div class="kf_list">
                    <div class="arrow_top">
                      <div class="arrow_inner"></div>
                    </div>
                    <ul></ul>
                  </div>
                </div>
              </div>
              或拨打电话：136-9946-5470
            </div>
          </div>
        </div>
        <div class="pay_way" v-show="payStatus == 'success'">
          <div class="content_succ">
            <div class="inner_succ">
              <i></i>
              <p class="wish">付款成功！祝您生活愉快！</p>
              <!-- <p class="num"><span>使用余额：<span style="color: #FB3509;">${{remainingMount}}</span></span></p> -->
              <p class="num">
                <span
                  >在线付款：<span style="color: #fb3509"
                    >￥{{ money }}</span
                  ></span
                >
              </p>
              <ul>
                <li @click="jump('OrderView')">返回订单</li>
                <li @click="jump('OrderView')">返回首页</li>
              </ul>
              <p class="deadline">
                <!-- <span>{{closeTime}}</span> 秒后跳转订单页面 -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </sd-modal>
  </div>
</template>
<script type="es6">
import { mapState, mapActions , mapGetters} from 'vuex'
import { util } from '../service/util'
import sdModal from '../components/sdModal'
let API = util.api([
    'UPDATEAMOUNTBYRECHARGE',
    'FINDPAYRESULTBYPAYID',
    'CLOSEPAYORDER',
    'FINDLASTRECHARGECHANNELBYCUSTOMERID',
    'FINDONLINEPAYCHANNEL',
]);
export default {
    name: 'recharge-view',
    components: { sdModal },
    data () {
        return {
            res : '',
            oldSearchStr:'',
            // 支付金额
            money:10,
            // 支付渠道
            payChannel:'',
            // 支付二维码
            QRCode: '',
            // 支付状态 ‘’、‘waiting’、‘success’
            payStatus: '',
            // 轮询的timer
            timer: '',
            // 自动关闭的时间
            closeTime: 180,
            // 临时的支付id
            payId: '',
            channelAlipay: '',
            channelWx: ''
        }
    },
    computed: {
        ...mapState({
            userInfo : state => state.common.userInfo,
        }),
        // 获取支付参数
        getPayParam() {
            return {
                money: this.money,
                payChannel: this.payChannel
            }
        },
        payWayLs() {
            return [this.channelAlipay || { id: 12 }, this.channelWx || { id: 1 }];
        },
    },
    methods: {
        toSearchPage() {
            window.open('http://www.sd235.net/search/result.html#oldSearchStr='+this.oldSearchStr);
        },
        // 跳转
        jump(name) {
            this.$router.push({
                name: name
            })
        },
        changeMoney($e) {
            // let money = parseFloat($e.target.value);
            let money = parseInt($e.target.value);
            // 小于1和错误
            if(!money || money < 1){
                money = 1;
            }
            // 大于可用余额
            if(money > 50000){
                money = 50000;
            }
            $e.target.value = money;
            this.money = money;
        },
        /**
         * 选择其他付款方式
         * - 解锁订单
         */
        cancelPay() {
            if(this.payStatus != 'waiting'){
                this.payStatus = '';
            } else {
                util.kAjax(API.CLOSEPAYORDER, { payId: this.payId }, res => {
                    clearInterval(this.timer);
                    this.payStatus = '';
                    this.QRCode = '';
                })
            }
        },
        // 轮询支付结果
        checkPayResult() {
            setInterval(this.timer);
            this.closeTime = 180;
            this.timer = setInterval(() => {
                util.kAjax(API.FINDPAYRESULTBYPAYID, {payId:this.payId}, res => {
                    this.closeTime -= 2;
                    if(this.closeTime  <= 0){
                        // 清空时长
                        clearInterval(this.timer);
                        // 关闭窗口
                        this.payStatus = '';
                        this.QRCode = '';
                    }
                    // 支付成功
                    if(res.data == 2){
                        this.payStatus = 'success';
                        this.QRCode = '';
                        clearInterval(this.timer);
                    }
                })
            },2000)
        },
        // 提交充值
        submitPay(payChannel) {

            // util.confirm.error('系统维护，暂时无法提供充值功能！');
            // return;

            // 支付渠道
            this.payChannel = payChannel;
            // 获取支付参数
            let param = this.getPayParam;
            util.kAjax(API.UPDATEAMOUNTBYRECHARGE, param, res => {

                // 获取临时支付id, 余额支付
                this.payId = res.data.payId;

                 // 显示微信支付二维码
                 this.QRCode = res.data.html;
                    this.payStatus = 'waiting';
                    // 轮询支付结果
                    this.checkPayResult();
            },err => {
                util.confirm.error(err);
            })
        },
        getChannel(){
            util.kAjax(API["FINDLASTRECHARGECHANNELBYCUSTOMERID"], {}, ({data = []}) => {
                let channel = data[0] ? data[0] : undefined;
              if (!channel) return;
              util.kAjax(API["FINDONLINEPAYCHANNEL"], {
                  tagId: +channel.tagId,
                }, ({data = []}) => {
                    this.channelWx = data.find((d) => d.onLineType == 1);
                    this.channelAlipay = data.find((d) => d.onLineType == 2);
                })
            })
        }
    },
    created() {
        this.$store.dispatch('getUserInfo');
        this.getChannel()
    },
    mounted(){

    }
}
</script>



// WEBPACK FOOTER //
// RechargeView.vue?59b1f66c